import Parse from 'parse'

/** True when `_User` has Google OAuth attached (`googleId` or `authData.google`). */
export function readParseGoogleLinked(): boolean {
  try {
    const u = Parse.User.current()
    if (!u) return false
    const auth = u.get('authData') as Record<string, unknown> | undefined
    return Boolean(u.get('googleId') || (auth && typeof auth === 'object' && 'google' in auth))
  } catch {
    return false
  }
}

/** True when the user has set a manual (non-Google-only) password. */
export function readParseHasManualPassword(): boolean {
  try {
    const u = Parse.User.current()
    if (!u) return false
    return u.get('hasManualPassword') === true
  } catch {
    return false
  }
}

/**
 * True when the account still owes us a password it can sign in with.
 *
 * Company invitations create the account with a server-generated password nobody
 * is ever told, and `hasManualPassword` is only set when the user picks one
 * themselves (sign-up, password reset, or the account password panel). So this is
 * the authoritative "onboarding unfinished" signal — it stays true for an invitee
 * who redeemed their link but abandoned the password step, which `emailVerified`
 * does not (that flips the moment the link is clicked).
 *
 * Google-only accounts are deliberately excluded: they legitimately have no
 * password and adding one is optional for them, so they must never be blocked.
 */
export function readParseNeedsPassword(): boolean {
  try {
    // Guard on the session first: with no current user both readers below return
    // false, which would otherwise make this report true and let a signed-out
    // state trigger the mandatory-password block.
    if (!Parse.User.current()) return false
  } catch {
    return false
  }
  return !readParseHasManualPassword() && !readParseGoogleLinked()
}
